import React from "react";
import "./Badge.scss";

interface Props {
  children: React.ReactNode;
  className?: string;
  variant: "success" | "danger" | "info" | "warning" | "secondary" | "outline" | "destructive";
  onClick?: () => void;
}

const Badge = ({ children, className, variant, onClick }: Props) => {
  return (
    <div 
      className={`badge badge-${variant} ${className} ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Badge;
